var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDescription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_67_436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6225 17.6425L28.9765 13.9965C28.7348 13.7547 28.4069 13.6189 28.065 13.6189C27.723 13.6189 27.3952 13.7547 27.1534 13.9965L16.0119 25.138C15.1092 26.0408 14.4997 27.1796 14.2493 28.4315L13.644 31.4582C13.5594 31.8808 13.6917 32.3177 13.9965 32.6224C14.2406 32.8666 14.5695 33 14.908 33C14.9921 33 15.0768 32.9918 15.1608 32.9749L18.1875 32.3696H18.1875C19.4394 32.1192 20.5782 31.5097 21.481 30.607L32.6225 19.4655C33.1259 18.9621 33.1259 18.146 32.6225 17.6425ZM19.6579 28.784C19.1163 29.3257 18.433 29.6914 17.6819 29.8416L16.5513 30.0677L16.7774 28.937C16.9276 28.1859 17.2933 27.5026 17.835 26.9609L28.065 16.7309L29.888 18.5539L19.6579 28.784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6505 30.4219H3.86719C3.1564 30.4219 2.57812 29.8436 2.57812 29.1328V3.86719C2.57812 3.1564 3.1564 2.57812 3.86719 2.57812H15.4688V6.44531C15.4688 8.57768 17.2036 10.3125 19.3359 10.3125H23.2031V11.1892C23.2031 11.9011 23.7802 12.4783 24.4922 12.4783C25.2041 12.4783 25.7812 11.9011 25.7812 11.1892V9.02337C25.7812 8.67442 25.634 8.33985 25.403 8.1113L17.6694 0.377566C17.4315 0.139734 17.0983 0 16.7578 0H3.86719C1.73482 0 0 1.73482 0 3.86719V29.1328C0 31.2652 1.73482 33 3.86719 33H9.6505C10.3625 33 10.9396 32.4229 10.9396 31.7109C10.9396 30.999 10.3624 30.4219 9.6505 30.4219ZM19.3359 7.73438C18.6251 7.73438 18.0469 7.1561 18.0469 6.44531V4.40112L21.3801 7.73438H19.3359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.625 13.6641C20.625 12.9521 20.0479 12.375 19.3359 12.375H6.44531C5.73336 12.375 5.15625 12.9521 5.15625 13.6641C5.15625 14.376 5.73336 14.9531 6.44531 14.9531H19.3359C20.0479 14.9531 20.625 14.376 20.625 13.6641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.44531 17.5312C5.73336 17.5312 5.15625 18.1084 5.15625 18.8203C5.15625 19.5323 5.73336 20.1094 6.44531 20.1094H16.8611C17.573 20.1094 18.1501 19.5323 18.1501 18.8203C18.1501 18.1084 17.573 17.5312 16.8611 17.5312H6.44531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9865 22.6875H6.44531C5.73336 22.6875 5.15625 23.2646 5.15625 23.9766C5.15625 24.6885 5.73336 25.2656 6.44531 25.2656H11.9865C12.6984 25.2656 13.2755 24.6885 13.2755 23.9766C13.2755 23.2646 12.6984 22.6875 11.9865 22.6875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_67_436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescription);
export default __webpack_public_path__ + "static/media/description.abdf20a8bc692b1a94ee785f528cad72.svg";
export { ForwardRef as ReactComponent };